'use client';

import type { CreateToasterProps } from '@chakra-ui/react';

import { toaster } from '../base';

export type ToastType = 'error' | 'info' | 'success' | 'warning';
export type ToastOption = {
	description?: string
	duration?:    number
	placement?:   CreateToasterProps['placement']
	title: 	      string
};

function createToastOption(type: ToastType, option: ToastOption) {
	return {
		...option,
		duration:  1500,
		placement: option.placement || 'top-end',
		type,
	};
}

export const useToast = () => {
	const showSuccess = (toasterProps: ToastOption) => {
		console.log('🚀 ~ showSuccess ~ toasterProps:', toasterProps);
		const options = createToastOption('success', toasterProps);
		toaster.create(options);
	};

	const showError = (toasterProps: ToastOption) => {
		const options = createToastOption('error', toasterProps);
		toaster.create(options);
	};

	const showInfo = (toasterProps: ToastOption) => {
		const options = createToastOption('info', toasterProps);
		toaster.create(options);
	};

	const showWarning = (toasterProps: ToastOption) => {
		const options = createToastOption('warning', toasterProps);
		toaster.create(options);
	};

	return {
		showError,
		showInfo,
		showSuccess,
		showWarning,
	};
};
